import { Button } from '@skipper/ui';
import React from 'react';
import { motion } from 'framer-motion';

export function Header({
    active,
    onClick,
    children,
}: {
    active: boolean;
    children: React.ReactNode;
    onClick: () => void;
}) {
    return (
        <Button
            type="button"
            variant="text"
            className={`flex gap-x-2 items-center relative `}
            onClick={onClick}
            css={{
                py: '$space$3',
                px: '$space$1',
                color: active ? '$colors$teal600' : '$colors$gray800',
                ['&:hover']: {
                    color: active ? '$colors$teal600' : '$colors$gray800',
                },
            }}>
            {children}
            {active && (
                <motion.div
                    layoutId="underline"
                    layout="position"
                    className="h-0.5 bg-teal-600 absolute bottom-0 left-0 right-0"
                />
            )}
        </Button>
    );
}

export function PanelContent({
    renderBody,
    renderFooter,
    columnsSpan = 2,
}: {
    renderBody: () => JSX.Element;
    renderFooter?: () => JSX.Element;
    columnsSpan?: Number;
}) {
    let colClass = 'md:grid-cols-2';
    if (columnsSpan === 4) {
        colClass = 'md:grid-cols-4';
    } else if (columnsSpan === 6) {
        colClass = 'md:grid-cols-6';
    }

    return (
        <div className="relative min-w-max rounded-b-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden h-full">
            <div className={`grid gap-2 bg-white grid-cols-2 ${colClass} h-full overflow-y-auto`}>
                {renderBody && renderBody?.()}
            </div>
            {renderFooter && <div className="bg-gray-50">{renderFooter?.()}</div>}
        </div>
    );
}
